/* global IntersectionObserver */

function generateTebleOfContent() {
	'use strict';

	const initTableOfContent = () => {
		const headers = document.querySelectorAll(
			'.single-post-cloudavocado .wp-block-post-content-is-layout-flow>h2'
		);

		if ( ! headers.length ) {
			return;
		}

		// add unique id for all headers
		headers.forEach( ( el, index ) => {
			if ( ! el.id ) {
				el.id = `title-${ index + 1 }`;
			}
		} );

		// create and add references in table of CONTENT
		const tableOfContent = document.querySelector(
			'.article-table-content'
		);
		headers.forEach( ( el, index ) => {
			if ( el.id ) {
				const link = document.createElement( 'a' );
				link.href = `#${ el.id }`;
				link.textContent = el.textContent;
				link.classList.add( 'reference-article-table' );
				if ( ! index ) {
					link.classList.add( 'active' );
				}
				tableOfContent.appendChild( link );
			}
		} );

		// logic for adding class active for clicked reference and removing from previous active
		const referencesArticleTable = tableOfContent.querySelectorAll(
			'.reference-article-table'
		);
		referencesArticleTable.forEach( ( ref ) =>
			ref.addEventListener( 'click', changeActiveReference )
		);

		function changeActiveReference() {
			referencesArticleTable.forEach( ( ref ) => {
				if ( ref.classList.contains( 'active' ) ) {
					ref.classList.remove( 'active' );
				}
			} );
			this.classList.add( 'active' );
		}

		// logic for toggle active content in table when we are scrolling
		const observer = new IntersectionObserver(
			( entries ) => {
				entries.forEach( ( entry ) => {
					if ( entry.isIntersecting ) {
						// save id title for searching in table of content
						const id = entry.target.id;
						referencesArticleTable.forEach( ( ref ) => {
							if ( ref.classList.contains( 'active' ) ) {
								ref.classList.remove( 'active' );
							}
							if ( ref.getAttribute( 'href' ) === `#${ id }` ) {
								ref.classList.add( 'active' );

								tableOfContent.scrollTo( {
									top:
										ref.offsetTop -
										tableOfContent.clientHeight / 2,
									behavior: 'smooth',
								} );
							}
						} );
					}
				} );
			},
			{
				threshold: 1,
			}
		);

		headers.forEach( ( el ) => observer.observe( el ) );
	};

	const addSpaceAboveTableOfContent = () => {
		// add space for table of content
		const firstChildInPostContent = document.querySelector(
			'.wp-block-post-content'
		)?.firstElementChild;

		if ( firstChildInPostContent ) {
			const styles = window.getComputedStyle( firstChildInPostContent );
			const totalSpace =
				( parseFloat( styles.marginTop ) || 0 ) +
				( parseFloat( styles.paddingTop ) || 0 );
			const wrapperTableOfContent = document.querySelector(
				'.wrapper-table-content'
			);
			if ( wrapperTableOfContent ) {
				wrapperTableOfContent.style.paddingTop = `${ totalSpace }px`;
			}
		}
	};

	initTableOfContent();
	addSpaceAboveTableOfContent();
}

document.addEventListener( 'DOMContentLoaded', generateTebleOfContent );
